export default {
  button: {
    display: 'inline-block',
    fontWeight: 'bold',
    textAlign: 'center',
    textDecoration: 'none',
    WebkitTextSizeAdjust: 'none',
    paddingLeft: '20px',
    paddingRight: '20px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
